import { Search } from "lucide-react";
import { Input } from "@/common/components/ui/input";
import { NewsCategory } from "../../types/news";

interface NewsFiltersProps {
  categories: NewsCategory[];
  activeCategory: string;
  searchTerm: string;
  onCategoryChange: (categoryId: string) => void;
  onSearchChange: (value: string) => void;
}

export const NewsFilters = ({
  categories,
  activeCategory,
  searchTerm,
  onCategoryChange,
  onSearchChange,
}: NewsFiltersProps) => {
  return (
    <div className="bg-background/95 sticky top-20 z-30 mb-8 border-b border-border/40 py-4 backdrop-blur-md">
      <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
        <div className="no-scrollbar flex w-full gap-2 overflow-x-auto pb-2 md:w-auto">
          {categories.map(cat => (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-medium transition-all ${
                activeCategory === cat.id
                  ? "bg-[#0c4a6e] text-white shadow-md"
                  : "border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        <div className="relative w-full md:w-auto md:min-w-[300px]">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="Search news..."
            className="rounded-full border-slate-200 bg-white pl-10"
            value={searchTerm}
            onChange={e => onSearchChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};
